<div class="custom-report-page-container">
  <div class="header-container">
    <div class="text-title-2">{{title}}</div>
  </div>

  <div class="table-controls-container">
    <form [formGroup]="customReportControlsForm"
          [ngClass]="{'active': isUsersDropdownOpened || isDrugsDropdownOpened || isActivityDropdownOpened}"
          [class.with-schedules]="enableC3toC5Drugs$ | async"
    >
      <div class="period-picker-container">
        <app-dropdown formControlName="period"
                      [label]="'Date Range'"
                      [placeholder]="'All Time'"
                      (chosenOption)="changePeriod($event)"
                      [isOptionObject]="true"
                      [options]="periodsList"
                      [isLoading]="isLoading$ | async"
                      (tabEnterEvent)="focusMultioptionalDropdown('usersMultioptionalDropdown')"
                      #periodDropdown
        ></app-dropdown>

        <app-datepicker-input formControlName="customPeriod"
                              [tabInd]="0"
                              [selectMode]="'range'"
                              [dateMax]="now()"
                              (dateTimeChange)="customPeriodChanged($event)"
                              (afterPickerClosed)="checkDateRangeAfterClosed()"
                              #customPeriodDatepicker
        ></app-datepicker-input>
      </div>

      <app-multiselect-dropdown formControlName="users"
                                id="users"
                                [id]="'users'"
                                [ngClass]="{'actual': isUsersDropdownOpened}"
                                [label]="'User'"
                                [placeholder]="'All Users'"
                                (dropDownOpened)="multiselectOpened('userItemsShowLimit', 'isUsersDropdownOpened')"
                                (dropDownClosed)="multiselectClosed('userItemsShowLimit', 'isUsersDropdownOpened')"
                                [data]="usersList"
                                [settings]="userListSettings"
                                [itemsLimit]="userItemsShowLimit"
                                [loading]="isLoading$ | async"
                                (tabEnterEvent)="focusMultioptionalDropdown('drugsMultioptionalDropdown')"
                                #usersMultioptionalDropdown
      ></app-multiselect-dropdown>

      <app-schedules-filter *ngIf="enableC3toC5Drugs$ | async"
        class="ml-2 mr-2"
        label="Schedule"
        [control]="customReportControlsForm.controls.schedules">
      </app-schedules-filter>

      <app-multiselect-dropdown formControlName="drugs"
                                id="drugs"
                                [id]="'drugs'"
                                [ngClass]="{'actual': isDrugsDropdownOpened}"
                                [label]="'Drug'"
                                [placeholder]="'All Drugs'"
                                (dropDownOpened)="multiselectOpened('drugItemsShowLimit', 'isDrugsDropdownOpened')"
                                (dropDownClosed)="multiselectClosed('drugItemsShowLimit', 'isDrugsDropdownOpened')"
                                [data]="drugsList"
                                [settings]="drugListSettings"
                                [itemsLimit]="drugItemsShowLimit"
                                [loading]="isLoading$ | async"
                                [shouldFilterByNDC]="true"
                                (tabEnterEvent)="focusMultioptionalDropdown('activityMultioptionalDropdown')"
                                #drugsMultioptionalDropdown
      ></app-multiselect-dropdown>

      <app-multiselect-dropdown formControlName="activityTypes"
                                id="activityTypes"
                                [id]="'activityTypes'"
                                [ngClass]="{'actual': isActivityDropdownOpened}"
                                [label]="'Activity'"
                                [placeholder]="'All Activity'"
                                (dropDownOpened)="multiselectOpened('activitiesItemsShowLimit', 'isActivityDropdownOpened')"
                                (dropDownClosed)="multiselectClosed('activitiesItemsShowLimit', 'isActivityDropdownOpened')"
                                [data]="activitiesList"
                                [settings]="activitiesListSettings"
                                [itemsLimit]="activitiesItemsShowLimit"
                                [loading]="isLoading$ | async"
                                #activityMultioptionalDropdown
      ></app-multiselect-dropdown>
      <app-inventory-locations-filter *ngIf="inventoryLocationsEnabled$ | async"
        class="ml-2"
        label="Location"
        [control]="customReportControlsForm.controls.inventoryLocations">
      </app-inventory-locations-filter>
    </form>

    <div class="header-controls">
      <app-button [text]="'Reset'"
                  styleClass="settings"
                  subStyle="blue"
                  customClasses="px-4 mr-2"
                  [minWidth]="0"
                  [disabled]="areFiltersEmpty() && !originalRecordsList?.length"
                  (clicked)="reset()"
      ></app-button>
      <app-button customClasses="px-4"
                  [text]="'Run Report'"
                  (clicked)="runReport()"
                  [loading]="runningReports$ | async"
      ></app-button>
    </div>
  </div>

  <div class="reports-table-container">
    <div *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && !isReportRunApplied" class="empty-list-container">
      <div class="icon-wrapper">
        <img class="chart-icon" src="assets/icons/icon-chart-active.svg" alt="report-icon"/>
      </div>
      <div class="empty-list-header">Results</div>
      <div class="empty-list-description">
        Your report data will show up here.
      </div>
    </div>

    <app-empty-table *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && isReportRunApplied"
                     [labelValue]="'There are no items to display.'"
                     [topOffset]="290"
    ></app-empty-table>

    <form [formGroup]="reportsTableControlsForm" class="table-controls" *ngIf="originalRecordsList?.length">
      <div class="left-block">
        <app-search-input formControlName="searchValue"
                          [color]="SearchInputColorEnum.Blue"
                          [placeholder]="'Start typing...'"
                          [hideDropdown]="true"
        ></app-search-input>
      </div>

      <div *ngIf="sortedRecordsList.length" class="right-block">
        <div class="heading">
          Results
        </div>
        <app-button [text]="'By User'"
                    styleClass="toggle"
                    [disabled]="isLoading$ | async"
                    [subStyle]="filterResultsBy === 'user' ? 'active' : 'unactive'"
                    [minWidth]="0"
                    customClasses="px-3 mr-8"
                    (clicked)="switchFilterResultBy('user')"
        ></app-button>
        <app-button [text]="'By Drug'"
                    styleClass="toggle"
                    [disabled]="isLoading$ | async"
                    [subStyle]="filterResultsBy === 'drug' ? 'active' : 'unactive'"
                    [minWidth]="0"
                    customClasses="px-3"
                    (clicked)="switchFilterResultBy('drug')"
        ></app-button>
      </div>
    </form>

    <table class="table-primary report-records-table" *ngIf="originalRecordsList?.length">
      <thead>
      <tr>
        <th (click)="sortByColumn('transactionDate')"
            class="text-left sort recorded" scope="col"
        >
        DATE/TIME
          <img [class.asc]="tableColumns.transactionDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th class="text-left sort drug" scope="col" *ngIf="filterResultsBy === 'user'">
          Drug
        </th>
        <th class="text-left sort drug" scope="col" *ngIf="filterResultsBy === 'drug'">
          Name
        </th>
        <th class="text-left sort activity" scope="col">
          Activity
        </th>
        <th class="text-left sort location" scope="col" *ngIf="inventoryLocationsEnabled$ | async">
          Location
        </th>
        <th class="text-right sort starting" scope="col">
          Starting
        </th>
        <th class="text-right sort count" scope="col">
          Count
        </th>
        <th class="text-right sort on-hand" scope="col">
          On-hand
        </th>
        <th class="text-left sort info" scope="col">
          Info
        </th>
      </tr>
      </thead>
      <tbody #tbody [appOverflowClass]>

      <app-search-empty-splash *ngIf="(isLoading$ | async) !== true && reportsTableControlsForm.get('searchValue')?.value && sortedRecordsList?.length === 0"
                               [searchValue]="reportsTableControlsForm.get('searchValue')?.value"
      ></app-search-empty-splash>

      <ng-container *ngFor="let group of sortedRecordsList; let i = index">
        <tr class="group-header-container" (click)="groupItemsOpened[i] = !groupItemsOpened[i]">
          <td colspan="8">
            <img [class.close]="!groupItemsOpened[i]" class="icon-toggle"
                 src="assets/icons/icon-toggle-chevron-green.svg"
                 alt="toggle-icon"/>
            <div class="group-header">
              {{group.header}}
            </div>
          </td>
        </tr>

        <ng-container *ngIf="groupItemsOpened[i]">
          <tr class="table-row"
              (click)="openWidgetForRecord(transaction)"
              *ngFor="let transaction of group.transactions; trackBy: trackByFn;"
          >
            <td class="text-left recorded">
              {{transaction?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
            </td>
            <th class="text-left drug" scope="row" *ngIf="filterResultsBy === 'user'">
              <div [title]="transaction['friendlyName']" class="heading">
                {{transaction['friendlyName']}}
              </div>
              <div class="secondary">
                {{transaction['packageNdc']}}
              </div>
            </th>
            <th class="text-left drug" scope="row" *ngIf="filterResultsBy === 'drug'">
              <div class="heading">
                  {{transaction?.firstName}} {{transaction?.lastName}}
              </div>
            </th>
            <td class="text-left activity">
              <app-badge [color]="(transaction | transactionBadge)?.color">
                {{(transaction | transactionBadge)?.label}}
              </app-badge>

            </td>
            <td class="text-left location location-td" *ngIf="inventoryLocationsEnabled$ | async">
              {{transaction?.locationName}}
            </td>
            <td class="text-right starting">
              {{transaction?.startingQuantity | number}}
            </td>
            <td class="text-right count">
              {{transaction?.addedQuantity | number}}
            </td>
            <td class="text-right on-hand">
              {{transaction?.endingQuantity | number}}
            </td>
            <td class="text-left info">
              <div class="heading" [auditOrderRedirectLinkClass] [activityType]="transaction?.activityType"
                (click)="openAuditOrOrder(transaction)">
                {{transaction?.infoHeading}}
              </div>
              <div class="secondary">
                {{transaction?.infoSecondary}}
              </div>
              <div *ngIf="transaction?.infoSecondary2"
                class="secondary"
              >
                {{transaction.infoSecondary2}}
              </div>
            </td>
          </tr>
        </ng-container>

      </ng-container>
      </tbody>
    </table>

  </div>
  <app-button *ngIf="sortedRecordsList?.length && originalRecordsList?.length"
    customClasses="ml-3 px-4 mr-3 flex-start min-w-[117px]" [text]="'Download'" appMenu [loading]="isFileDownloading"
    [minWidth]="117" justifyTextPosition="left" [autoClose]="'outside'"
    [menuContent]="downloadMenuContent" triggers="manual" #downloadMenu="appMenu"
    (click)="downloadMenu.toggle();$event.stopPropagation();" [ngClass]="(loadingLibertyRxInventory$ | async) ? 'download-btn-left' : 'download-btn'">
    <img [class.opened]="downloadMenu.isOpen()" class="download-btn-icon" src="assets/icons/icon-chevron-down-white.svg"
      alt="chevron-down" />
  </app-button>
  <ng-template #downloadMenuContent>
    <div class="menu-container primary">
      <div (click)="savePDF();downloadMenu.close();$event.stopPropagation()" class="menu-item">
        <div class="option">Export as PDF</div>
      </div>
      <div (click)="saveCSV();downloadMenu.close();$event.stopPropagation()" class="menu-item">
        <div class="option">Save as CSV</div>
      </div>
    </div>
  </ng-template>
</div>
